const API_BASE = import.meta.env.VITE_NODE_ENV === 'production' 
  ? 'https://serv.adacadabra.ai' 
  : 'http://localhost:8080';

export const API_ENDPOINTS = {
  GENERATE_PROMPTS: `${API_BASE}/api/prompts/generate`,
  UPLOAD_IMAGE: `${API_BASE}/api/images/upload`,
  ANALYZE_IMAGE: `${API_BASE}/api/images/analyze`,
  ANALYZE_TEXT: `${API_BASE}/api/text/analyze`,
  TRANSCRIBE_AUDIO: `${API_BASE}/api/audio/transcribe`,
  GENERATE_POST: `${API_BASE}/api/audio/generate-post`,
  SAVE_RECORDING: `${API_BASE}/api/audio/recordings`,
  UPDATE_TRANSCRIPT: `${API_BASE}/api/audio/recordings/:id/transcript`,
  SAVE_POST: `${API_BASE}/api/audio/posts`,
  TEXT_ANALYSIS: '/api/text-analysis'
};
